'use client';

import styles from './DownloadCarInfo.module.scss';
import DownloadCars from './Cars/DownloadCars';
import DownloadSegmented from './Segmented/DownloadSegmented';
import { useState, useEffect } from 'react';

const DownloadCarInfo = ({ downloadCenterCars }) => {
  // 调试：检查数据结�?

  // 如果没有数据，直接返回空状�?
  if (!downloadCenterCars || downloadCenterCars.length === 0) {
    return (
      <div className={styles.wrapper} data-aos="fade-up">
        <div style={{ padding: '60px 20px', textAlign: 'center' }}>
          <h2>No download content available</h2>
          <p>Please check back later for available downloads.</p>
        </div>
      </div>
    );
  }

  // 按照老项目的模式处理数据
  const newDownloadCenterCars = downloadCenterCars.map((item, index) => ({
    ...item,
    index,
  }));

  const [currentItem, setCurrentItem] = useState(
    newDownloadCenterCars.length > 0 ? newDownloadCenterCars[0] : null
  );

  useEffect(() => {
    if (newDownloadCenterCars.length > 0) {
      // 根据当前选中项的索引，在最新数据中查找对应项
      const updatedItem = newDownloadCenterCars.find((item) => item.index === currentItem?.index);
      if (updatedItem) {
        // 避免引用相同导致 React 跳过更新，可创建新对象
        setCurrentItem({ ...updatedItem });
      } else {
        // 如果找不到对应项（例如数据被重置），则回退到第一项
        setCurrentItem(newDownloadCenterCars[0]);
      }
    } else {
      setCurrentItem(null);
    }
  }, [downloadCenterCars, currentItem?.index]);

  // 安全检查：如果没有数据，返回空组件
  if (!currentItem) {
    return null;
  }

  const handleClick = (index) => {
    const selectedItem = newDownloadCenterCars.find((el) => el.index === index) || currentItem;
    setCurrentItem(selectedItem);
  };

  const segmentedItems = newDownloadCenterCars.map((item) => ({
    title: item.title,
    index: item.index,
  }));

  return (
    <div className={styles.wrapper} data-aos="fade-up">
      <div className={styles.segmented} data-aos="fade-up">
        <DownloadSegmented
          items={segmentedItems}
          activeIndex={currentItem.index}
          onClick={handleClick}
        />
      </div>
      <DownloadCars item={currentItem} />
    </div>
  );
};

export default DownloadCarInfo;
